import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { setArcToStudy } from "../../../api/cro";
import { getStudySponsors } from "../../../api/study";
import { ReactComponent as WomanPatient } from "../../../assets/illustrations/illustration-femme-patient.svg";
import { ReactComponent as ManPatient } from "../../../assets/illustrations/illustration-homme-patient.svg";
import Button from "../../../components/ButtonUI";
import Modal from "../../../components/ModalUI";
import makeToast from "../../../components/Snackbar";
import Spinner from "../../../components/Spinner";
import * as Yup from "yup";
import Input from "../../../components/FloatInput";
import "./styles.scss";
import { Field, Form, Formik } from "formik";
import { addSponsor } from "../../../api/sponsor";
const colorAvatar = [
  "#ccd2ff",
  "#d5f0f7",
  "#ffecba",
  "#fff7ab",
  "#ffccd2",
  "#ffe2c8",
];

type Props = {
  studyId: string;
  modalAfectation: boolean;
  setModalAfectation: React.Dispatch<React.SetStateAction<string>>;
  studyConfig: any;
  setUpdateStudy: any;
};

const validationSchema = Yup.object().shape({
  firstName: Yup.string().required("First name is required"),
  lastName: Yup.string().required("Last name is required"),
  email: Yup.string().email("Invalid email").required("Email is required"),
});

const MesSponsors: React.FC<Props | any> = ({
  studyId,
  modalAfectation,
  setModalAfectation,
}) => {
  const [selectedDoctor, setSelectedDoctor] = useState() as any;

  const [loading] = useState(false);

  const [loadList, setLoadList] = React.useState<any>(false);
  const [sponsors, setSponsorsStudy] = useState([]) as any[];
  const [selectedIds, setSelectedIds] = useState([]); // ids marked resources
  const { t } = useTranslation() as any;

  // Event triggered after change marked options,
  // if checked options equal selectedResource,
  // no changes have occurred, the event will not be triggered

  async function fetchMyAPI(): Promise<void> {
    let v1 = await getStudySponsors(studyId);
    if (v1) {
      setSponsorsStudy(v1);
    }
  }

  useEffect(() => {
    fetchMyAPI();
  }, [loadList]);

  return loading ? (
    <Spinner />
  ) : (
    <>
      <div className=" my-patients mt-12">
        <div
          className={`patient-list flex flex-wrap gap-y-10 justify-between w-full"`}
        >
          {sponsors && sponsors.length !== 0 ? (
            sponsors
              .sort(
                (a: any, b: any) =>
                  Number(new Date(b.createdAt)) - Number(new Date(a.createdAt)),
              )
              .map((e, i) => {
                return (
                  <div
                    className={`card-patient justify-between bg-white p-4 relative ${
                      selectedDoctor?._id === e?._id
                    }`}
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      setSelectedDoctor(e);
                    }}
                  >
                    <div className="flex patient-info">
                      <div
                        className="rounded-full h-12 w-12 flexCenter mx-5 my-auto"
                        style={{
                          backgroundColor: colorAvatar[i % colorAvatar.length],
                          cursor: "pointer",
                        }}
                      >
                        {e?.gender === "male" ? (
                          <ManPatient />
                        ) : (
                          <WomanPatient />
                        )}
                      </div>
                      <div className="details" style={{ cursor: "pointer" }}>
                        <div className="flex-grow ">
                          <p
                            className="card-title capitalize"
                            style={{ cursor: "pointer" }}
                          >
                            {e.firstName} {e.lastName}
                          </p>
                          <p className="card-subtitle">
                            <span>{e.email}</span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })
          ) : (
            <div className="w-full flexCenter mt-24">
              <h3>{t("SideBar.NoMemberFound")}</h3>
            </div>
          )}
        </div>

        <Modal
          closeModal={() => {
            setModalAfectation(false);
            setSelectedIds([]);
          }}
          showModal={modalAfectation}
          className="md:p-10 xs:p-5 md:m-16 xs:m-6 "
        >
          <Formik
            initialValues={{
              firstName: "",
              lastName: "",
              email: "",
              studyId: studyId,
            }}
            validationSchema={validationSchema}
            onSubmit={(values, { setSubmitting }) => {
              setTimeout(() => {
                alert(JSON.stringify(values, null, 2));
                setSubmitting(false);
              }, 400);
            }}
          >
            {({ isSubmitting, values, isValid, handleChange }) => (
              <Form className="flex-auto py-7 px-8 min-w-full	">
                <div className="flex flex-wrap items-baseline">
                  <h1 className="mb-10 text-center">
                    {" "}
                    {t("SideBar.SponsorToEquipe")}
                  </h1>
                </div>
                <Input
                  type="text"
                  id="firstName"
                  name="firstName"
                  labelText={t("Profile.name")}
                  placeholder={t("Profile.name")}
                  className="py-2 px-4"
                  onChange={handleChange}
                />

                <Input
                  type="text"
                  id="lastName"
                  name="lastName"
                  labelText={t("SideBar.lastName")}
                  placeholder={t("SideBar.lastName")}
                  className="py-2 px-4"
                  onChange={handleChange}
                />

                <Input
                  type="email"
                  id="email"
                  name="email"
                  labelText="email"
                  placeholder="email"
                  className="py-2 px-4"
                  onChange={handleChange}
                />

                <div className="flex justify-between mb-4">
                  <div>
                    {" "}
                    <Button
                      type="button"
                      width="100px"
                      height="50px"
                      status="secondary"
                      className="mt-2 btn-delete"
                      onClick={() => setModalAfectation(false)}
                    >
                      {t("SideBar.Cancel")}
                    </Button>
                  </div>

                  <div>
                    {" "}
                    <Button
                      type="submit"
                      status="secondary"
                      width="100px"
                      height="50px"
                      className="mt-2"
                      disabled={isSubmitting || !isValid}
                      onClick={async () => {
                        const res = await addSponsor(values);

                        if (res.status === 201 && res.data) {
                          makeToast("success", "Sponsor added successfully");
                          setLoadList((l) => !l);
                          setModalAfectation(false);
                        }
                      }}
                    >
                      {t("SideBar.Add")}
                    </Button>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </Modal>
      </div>
    </>
  );
};
export default MesSponsors;
